export { createEpicMiddleware } from './createEpicMiddleware';
export { ActionsObservable } from './ActionsObservable';
export { combineEpics } from './combineEpics';
export { EPIC_END } from './EPIC_END';


//////////////////
// WEBPACK FOOTER
// ./~/redux-observable/lib/es/index.js
// module id = 302
// module chunks = 0